
import { InfoCircleOutlined } from "@ant-design/icons";
import { Divider, Tag, Tooltip } from "antd";
import moment from "moment";

export default function ReviewComment({ comment, scope, reviewReplyUpdateTime, isReply }) {

  return (
    <div className='comment-review' style={{color: scope ? 'lightseagreen' : 'slategrey', marginBottom:'10px'}}>
      { 
        comment?.originalText ? comment?.originalText : comment?.text
      }
      <i style={{display:'flex', justifyContent:'right', color: isReply ? 'lightseagreen' : 'slategrey' }}>
        <small style={{ borderRadius: '20px', marginTop:'10px' }}>
          <div>{moment(reviewReplyUpdateTime).format('ll')}</div>
          {/*scope && <>{SCOPE_LABELS[scope]}</>*/}
        </small>
      </i>
      {
        comment?.translatedText &&
          <div>
            <Divider style={{margin: '10px 0px'}}/>
            <small style={{color:'#bbc'}}>            
              <i><b>Translated By Google:</b> {comment?.translatedText}</i>
            </small>
          </div>
      }
    </div>
  );
}

/*export const SCOPE_LABELS = {
  SYNC: '',
  MANUAL: 'Respuesta manual',
  AUTOMATED: 'Respuesta automática',   
}*/
